<template>
  <div class="body">
    <div class="v-form" style="border: none">
      <header>
        <div class="row">
          <div class="col-xs-12 text-center">
            <img
              src="https://manager.venuzle.at/assets/images/venuzle-white-1280.png"
              width="300"
              class="img-responsive"
              alt="VENUZLE Manager"
            />
          </div>
        </div>
      </header>
      <input type="hidden" name="type" value="login" />
      <fieldset>
        <section v-if="false">
          <div class="row">
            <div class="col-xs-12">
              <em class="login-error state-error"> </em>
            </div>
          </div>
        </section>
        <section>
          <div class="row">
            <div class="col-xs-12">
              <label class="label">{{
                $label("common.email_address_short", "E-Mail")
              }}</label>
              <label class="input">
                <input
                  v-model="email"
                  v-on:keyup.enter="login"
                  id="email"
                  class="login-input"
                  :class="{ 'text-input-error': hasError('email') }"
                  type="email"
                  name="email"
                  :placeholder="$label('common.email_address_short')"
                />
              </label>
              <p v-if="hasError('email')" class="text-danger text-bold">
                {{ getError("email") }}
              </p>
            </div>
          </div>
        </section>
        <section>
          <div class="row">
            <div class="col-xs-12">
              <label class="label">{{
                $label("common.password", "Password")
              }}</label>
              <label class="input">
                <input
                  v-model="password"
                  v-on:keyup.enter="login"
                  id="password"
                  class="login-input"
                  :class="{ 'text-input-error': hasError('password') }"
                  type="password"
                  name="password"
                  :placeholder="$label('common.password', 'Password')"
                />
              </label>
              <p v-if="hasError('password')" class="text-danger">
                {{ getError("password") }}
              </p>
            </div>
          </div>
        </section>

        <section>
          <div class="row">
            <div class="col-xs-12">
              <label class="checkbox">
                <input
                  type="checkbox"
                  name="remember"
                  value="rememberMe"
                /><i></i>Anmeldung merken
              </label>
            </div>
          </div>
        </section>
      </fieldset>
      <footer>
        <div class="row">
          <div class="col-xs-12">
            <button
              @click="login"
              class="btn btn-block btn-primary blue-button"
            >
              <i class="fa fa-fw fa-sign-in"></i>
              {{ $label("common.login", "Log In") }}
            </button>
          </div>
        </div>
      </footer>

      <section class="text-center">
        <div class="row">
          <div class="col-xs-12">
            <a class="reset-password-text" href="/login/send-token/"
              >Passwort vergessen?</a
            >
          </div>
        </div>
      </section>
    </div>
    <partner-modal :partners="partners" :showModal="showPartnerModal" />
  </div>
</template>

<script>
import Api from "@/api";
import FormErrorsMixin from "@/mixins/FormErrors.js";
import PartnerModal from "@/components/PartnerModal";

export default {
  mixins: [FormErrorsMixin],

  components: {
    PartnerModal
  },

  data() {
    return {
      email: "",
      password: "",
      validatedInputs: ["email", "password"],
      loggingIn: false,
      partners: [],
      showPartnerModal: false
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.setLoginBackgroundColor();
      vm.getUsers(() => {
        //
      });
    });
  },

  methods: {
    login() {
      if (this.loggingIn) {
        return;
      }

      this.resetErrors();
      this.loggingIn = true;

      Api()
        .get("/sanctum/csrf-cookie")
        .then(() => {
          Api()
            .post("/api/internal/v1/login", this.loginCredentials)
            .then(response => {
              this.partners = response.data.data;
              if (this.partners.length > 1) {
                this.showPartnerModal = true;
              } else if (this.partners.length === 1) {
                localStorage.setItem("partnerId", this.partners[0].id);
                localStorage.setItem("partnerCode", this.partners[0].code);
                this.$router.push({
                  name: "UsersOverview"
                });
              }
            })
            .catch(error => {
              console.log(error.response.data.errors);
              this.storeErrors(error.response.data.errors);
            })
            .finally(() => {
              this.loggingIn = false;
            });
        });
    },

    getUsers() {
      if (
        localStorage.getItem("partnerId") != "" &&
        localStorage.getItem("partnerId") != null
      ) {
        let responseCode = 401;

        Api()
          .get(
            "/api/internal/v1/partners/" +
              localStorage.getItem("partnerId") +
              "/users?page=1&search=",
            { params: { page: 1, search: "" } }
          )
          .then(response => {
            responseCode = response.status;
          })
          .catch(response => {
            responseCode = response.status;
          })
          .finally(() => {
            if (responseCode == 200) {
              this.$router.push({
                name: "UsersOverview"
              });
            }
          });
      }
    },

    setLoginBackgroundColor() {
      const el = document.body;
      el.classList.remove("bg-color");
      el.classList.add("bg-color-login");
    },

    setDefaultBackgroundColor() {
      const el = document.body;
      el.classList.add("bg-color");
      el.classList.remove("bg-color-login");
    }
  },

  computed: {
    loginCredentials() {
      return {
        email: this.email,
        password: this.password
      };
    }
  },

  destroyed() {
    this.setDefaultBackgroundColor();
  }
};
</script>

<style scoped>
* {
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
}

a {
  text-decoration: underline;
}
a:hover {
  text-decoration: none;
}

.v-form a {
  color: #0088cc;
}

.body {
  max-width: 400px;
  margin: 0 auto;
  padding: 40px;
  box-sizing: content-box;
  -moz-box-sizing: content-box;
}

.modal a {
  color: #2da5da;
}

.v-form {
  margin: 0;
  outline: none;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  font: 13px/1.55 "Open Sans", Helvetica, Arial, sans-serif;
  color: #666;
}

.v-form header {
  display: block;
  padding: 20px 20px 40px 20px;
  border-bottom: 0px solid rgba(0, 0, 0, 0.1);
  background-color: #3aa94c;
}

.v-form footer {
  padding: 15px 30px 30px 30px;
  border-top: 0px solid rgba(0, 0, 0, 0.1);
  background-color: #3aa94c;
}

.v-form .checkbox {
  font-size: 14px;
}

.login-input {
  height: 50px !important;
}

.v-form .label {
  color: white !important;
  font-size: 16px;
  font-weight: bold;
}

.reset-password-text {
  color: white !important;
  font-size: 14px;
  text-decoration: underline;
}

.v-form .checkbox {
  color: white;
  cursor: pointer;
}

.v-form fieldset {
  display: block;
  padding: 0px 25px 0px;
  border: none;
  background-color: #3aa94c;
}

.img-responsive {
  display: initial;
  max-width: 100%;
  height: auto;
}

.blue-button {
  background-color: #0088cc;
  border-color: #0088cc;
  color: white;
  font-weight: bold;
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 22px;
}

@media screen and (max-width: 600px) {
  .body {
    padding: 20px;
  }
}

.v-form input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
}

.login-error {
  color: #fd6d00;
  font-weight: bold;
  float: left;
  background-color: white;
  padding: 5px;
  font-size: 16px;
}

/**/
/* error state */
/**/
.v-form .state-error input,
.v-form .state-error select,
.v-form .state-error textarea,
.v-form .radio.state-error i,
.v-form .checkbox.state-error i,
.v-form .toggle.state-error i {
  background: #d8f3ff;
}

.v-form .state-error select + i {
  background: #d8f3ff;
  box-shadow: 0 0 0 12px #d8f3ff;
}
.v-form .toggle.state-error input:checked + i {
  background: #d8f3ff;
}
.v-form .state-error + em {
  color: #fd6d00;
  background-color: white;
  padding: 5px;
  font-weight: bold;
  font-size: 12px;
}
</style>
